import WebhookType from './webhook-type.entity';

export default class WebhookListItem {
  id: string;

  createdBy: string;

  hasBasicAuthentication: string;

  url: string;

  username: string;

  password: string;

  webhookType: WebhookType;

  readOnly: boolean;

  constructor(obj: any = {}) {
    this.id = obj.id;
    this.createdBy = obj.createdBy;
    this.hasBasicAuthentication = obj.hasBasicAuthentication;
    this.url = obj.url;
    this.username = obj.username;
    this.password = obj.password;
    this.webhookType = new WebhookType(obj.webhookType);
    this.readOnly = obj.readOnly ?? false;
  }
}
